import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TipoServicoService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getTiposServico(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposervico' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTiposVeiculo(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposveiculo' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTipoServico(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposervico/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaTipoServico(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/tiposervico', {
				tipo_servico_nome: data.tipo_servico_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoServico(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tiposervico/' + data.tipo_servico_id, {
				tipo_servico_nome: data.tipo_servico_nome,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoServico(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tiposervico/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
